module.exports = __webpack_public_path__ + "img/handling-complain.cf0a5771.jpg";